import {branch, renderNothing, withHandlers} from 'recompose'

import type {MouseEvent} from 'react'
import {connect} from 'react-redux'

import {openDialog} from '../../../../../actions'
import type {DialogProps} from '../../../../../hocs/withDialogContainer'
import withDialogContainer from '../../../../../hocs/withDialogContainer'
import type {State} from '../../../../../reducers/types'
import {DialogType, stringifyId} from '../../../../../types'
import {showTestMetadataGraph} from '../../Tests.actions'
import {getTestOccurrence} from '../../Tests.selectors'

import DetailsPopup from './TestMetadataPopup'
import type {OwnProps, Props, ActionProps} from './TestMetadataPopup.types'

const actionCreators: ActionProps = {
  showTestMetadataGraph,
  openDialog,
}

const mapStateToProps = (state: State, {testOccurrenceId}: Props) => {
  const testOccurrence = getTestOccurrence(state, testOccurrenceId)
  return {
    buildId: testOccurrence?.build?.id,
    buildTypeId: testOccurrence?.build?.buildTypeId,
    testId: testOccurrence?.test?.id,
    testName: testOccurrence?.name,
  }
}

export default withDialogContainer(DialogType.METADATA_DETAIL_POPUP, (state, props: OwnProps) =>
  stringifyId(props.testOccurrenceId),
)(
  branch(
    (props: DialogProps) => !props.isOpened,
    renderNothing,
  )(
    connect(
      mapStateToProps,
      actionCreators,
    )(
      withHandlers({
        showTestMetadataGraphHandler:
          ({testId, buildId, buildTypeId, showTestMetadataGraph: showTest}: Props) =>
          (escapedName: string | undefined, event: MouseEvent) =>
            testId != null &&
            buildId != null &&
            buildTypeId != null &&
            escapedName != null &&
            showTest(event.currentTarget, testId, buildId, escapedName, buildTypeId),
      })(DetailsPopup),
    ),
  ),
)
